import { defineComponent, markRaw, h, ref, computed, onBeforeUnmount, openBlock, createElementBlock, createVNode, withCtx, renderSlot, unref, createElementVNode, toDisplayString, normalizeStyle, createCommentVNode, Fragment, renderList, createBlock, Teleport, withModifiers, normalizeClass, resolveDynamicComponent, nextTick } from "vue";
import { offset, flip, shift, useFloating, autoUpdate } from "@floating-ui/vue";
import SearchIcon from "../../assets/icons/search.svg2.js";
import ChevronRightIcon from "../../assets/icons/chevron-right.svg.js";
import Globe02StrokeRoundedIcon from "../../assets/icons/outline/globe-02-stroke-rounded.svg.js";
import { useDirection } from "../../composables/useDirection.js";
import Avatar from "../avatar/Avatar.vue.js";
import Dropdown from "../dropdown/Dropdown.vue.js";
import Input from "../input/Input.vue.js";
import ProfileDropdownItem from "./ProfileDropdownItem.vue.js";
import ProfileDropdownMenuItem from "./ProfileDropdownMenuItem.vue.js";
const _hoisted_1 = { class: "profile-dropdown" };
const _hoisted_2 = {
  key: 0,
  type: "button",
  class: "profile-dropdown__trigger profile-dropdown__trigger--name"
};
const _hoisted_3 = { class: "profile-dropdown__user-name profile-dropdown__user-name--ellipsis" };
const _hoisted_4 = {
  key: 1,
  type: "button",
  class: "profile-dropdown__trigger profile-dropdown__trigger--avatar"
};
const _hoisted_5 = {
  key: 0,
  class: "profile-dropdown__search"
};
const _hoisted_6 = { class: "profile-dropdown__menu-content" };
const _hoisted_7 = {
  key: 0,
  class: "profile-dropdown__header"
};
const _hoisted_8 = { class: "profile-dropdown__header-info" };
const _hoisted_9 = { class: "profile-dropdown__header-name" };
const _hoisted_10 = {
  key: 0,
  class: "profile-dropdown__header-email"
};
const _hoisted_11 = {
  key: 1,
  class: "profile-dropdown__divider"
};
const _hoisted_12 = {
  key: 2,
  class: "profile-dropdown__accounts-wrapper"
};
const _hoisted_13 = { class: "profile-dropdown__accounts" };
const _hoisted_14 = {
  key: 0,
  class: "profile-dropdown__menu-items"
};
const _hoisted_15 = {
  key: 0,
  class: "profile-dropdown__divider"
};
const _hoisted_16 = ["onMouseenter", "onMouseleave"];
const _hoisted_17 = ["onMouseenter", "onClick"];
const _hoisted_18 = {
  key: 0,
  class: "profile-dropdown__submenu-item-icon"
};
const _hoisted_19 = { class: "profile-dropdown__submenu-item-info" };
const _hoisted_20 = { class: "profile-dropdown__submenu-item-name" };
const _hoisted_21 = {
  key: 0,
  class: "profile-dropdown__submenu-item-description"
};
const _hoisted_22 = {
  key: 2,
  class: "profile-dropdown__submenu-item-chevron"
};
const _hoisted_23 = {
  key: 0,
  class: "profile-dropdown__search profile-dropdown__search--submenu"
};
const _hoisted_24 = ["onClick"];
const _hoisted_25 = { class: "profile-dropdown__submenu-item-info" };
const _hoisted_26 = { class: "profile-dropdown__submenu-item-name" };
const _hoisted_27 = {
  key: 0,
  class: "profile-dropdown__submenu-item-description"
};
const _hoisted_28 = {
  key: 1,
  class: "profile-dropdown__timezone"
};
const _hoisted_29 = { class: "profile-dropdown__timezone-content" };
const _hoisted_30 = { class: "profile-dropdown__timezone-icon" };
const _hoisted_31 = { class: "profile-dropdown__timezone-text" };
const _hoisted_32 = { class: "profile-dropdown__timezone-label" };
const _hoisted_33 = {
  key: 0,
  class: "profile-dropdown__timezone-offset"
};
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "ProfileDropdown",
  props: {
    accounts: { default: () => [] },
    modelValue: {},
    menuItems: { default: () => [] },
    valueKey: { default: "id" },
    labelKey: { default: "name" },
    avatarKey: { default: "avatar" },
    descKey: { default: "description" },
    userName: {},
    userEmail: {},
    userAvatar: {},
    displayMode: { default: "name" },
    isAdmin: { type: Boolean, default: false },
    maxWidth: { default: "300px" },
    searchable: { type: Boolean, default: false },
    searchPlaceholder: { default: "Find account" },
    timezone: { default: "" },
    timezoneOffset: { default: "" }
  },
  emits: ["update:modelValue", "select", "viewProfile", "settings", "support", "signOut"],
  setup(__props, { expose: __expose, emit: __emit }) {
    const StarBadge = markRaw(
      () => h(
        "div",
        {
          class: "rounded-full flex items-center justify-center w-full h-full",
          style: {
            background: "linear-gradient(180deg, #43476B 0%, #14142B 100%)",
            padding: "2px"
          }
        },
        [
          h(
            "svg",
            {
              xmlns: "http://www.w3.org/2000/svg",
              viewBox: "0 0 9 9",
              fill: "none"
            },
            [
              h("path", {
                d: "M4.47835 0C4.91556 0 5.25994 0.330221 5.47977 0.775796L6.21398 2.25632C6.23623 2.30214 6.28902 2.36666 6.36835 2.42568C6.4476 2.48465 6.52523 2.51717 6.57627 2.52575L7.90527 2.74839C8.38535 2.82905 8.78773 3.06437 8.91835 3.47413C9.04885 3.88354 8.85765 4.309 8.5124 4.65483L8.51206 4.65521L7.47961 5.69621C7.43869 5.73746 7.39285 5.81517 7.3641 5.91642C7.33556 6.017 7.33302 6.10863 7.34598 6.16779L7.34615 6.16863L7.64152 7.45642C7.76406 7.99237 7.72344 8.52388 7.34544 8.80175C6.96611 9.08054 6.44777 8.95696 5.97685 8.6765L4.73106 7.93292C4.67873 7.90167 4.5889 7.87633 4.48044 7.87633C4.37277 7.87633 4.28106 7.90133 4.22531 7.93375L4.22452 7.93421L2.98118 8.67633C2.51083 8.95779 1.99312 9.07917 1.61378 8.80008C1.23602 8.52217 1.19337 7.99167 1.31628 7.45612L1.6116 6.16863L1.61178 6.16779C1.62473 6.10863 1.6222 6.017 1.59365 5.91642C1.5649 5.81517 1.51906 5.73746 1.47814 5.69621L0.444917 4.65442C0.101917 4.30858 -0.0886832 3.8835 0.0407918 3.47469C0.170642 3.06469 0.572242 2.82908 1.05262 2.74836L2.38053 2.52591L2.38095 2.52584C2.42963 2.5174 2.5061 2.48523 2.58518 2.42612C2.6644 2.36689 2.71731 2.30223 2.73961 2.25632L2.74074 2.25403L3.47399 0.775404L3.47428 0.774821C3.69623 0.329617 4.04165 0 4.47835 0Z",
                fill: "url(#paint0_linear_16385_829)"
              }),
              h("defs", {}, [
                h(
                  "linearGradient",
                  {
                    id: "paint0_linear_16385_829",
                    x1: "4.47979",
                    y1: "0",
                    x2: "4.47979",
                    y2: "8.95891",
                    gradientUnits: "userSpaceOnUse"
                  },
                  [
                    h("stop", { "stop-color": "#FEFDF0" }),
                    h("stop", { offset: "1", "stop-color": "#FDE272" })
                  ]
                )
              ])
            ]
          )
        ]
      )
    );
    const props = __props;
    const emit = __emit;
    const searchQuery = ref("");
    const activeSubmenuIndex = ref(null);
    const menuRowRefs = ref({});
    let submenuCloseTimer = null;
    const dropdownRef = ref(null);
    const activeSubmenuAnchor = ref(null);
    const submenuFloatingRef = ref(null);
    const nestedSubmenuFloatingRef = ref(null);
    const submenuItemRefs = ref({});
    const activeNestedSubmenuIndex = ref(null);
    const activeNestedSubmenuAnchor = ref(null);
    const nestedSubmenuSearchQuery = ref("");
    const { isRtl } = useDirection();
    const submenuPlacement = computed(
      () => isRtl.value ? "left-start" : "right-start"
    );
    const nestedSubmenuPlacement = computed(
      () => isRtl.value ? "right-start" : "left-start"
    );
    const submenuFlipFallbackPlacements = computed(
      () => isRtl.value ? ["right-start", "left-start"] : ["left-start", "right-start"]
    );
    const nestedSubmenuFlipFallbackPlacements = computed(
      () => isRtl.value ? ["left-start", "right-start"] : ["right-start", "left-start"]
    );
    const submenuMiddleware = computed(() => [
      offset(({ placement }) => {
        const anchor = activeSubmenuAnchor.value;
        if (!anchor) return 8;
        const menuPanel = anchor.closest(".profile-dropdown__menu");
        if (!menuPanel) return 8;
        const menuRect = menuPanel.getBoundingClientRect();
        const anchorRect = anchor.getBoundingClientRect();
        const gap = 8;
        if (placement.startsWith("left")) {
          return anchorRect.left - menuRect.left + gap;
        }
        return menuRect.right - anchorRect.right + gap;
      }),
      flip({ fallbackPlacements: submenuFlipFallbackPlacements.value }),
      shift({ padding: 8 })
    ]);
    const nestedSubmenuMiddleware = computed(() => [
      offset(8),
      flip({ fallbackPlacements: nestedSubmenuFlipFallbackPlacements.value }),
      shift({ padding: 8 })
    ]);
    const { floatingStyles: submenuFloatingStyles } = useFloating(
      activeSubmenuAnchor,
      submenuFloatingRef,
      {
        placement: submenuPlacement,
        strategy: "fixed",
        middleware: submenuMiddleware,
        whileElementsMounted: autoUpdate
      }
    );
    const { floatingStyles: nestedSubmenuFloatingStyles } = useFloating(
      activeNestedSubmenuAnchor,
      nestedSubmenuFloatingRef,
      {
        placement: nestedSubmenuPlacement,
        strategy: "fixed",
        middleware: nestedSubmenuMiddleware,
        whileElementsMounted: autoUpdate
      }
    );
    const activeAccount = computed(() => {
      if (!props.accounts.length) return null;
      if (props.modelValue !== void 0) {
        const found = props.accounts.find(
          (account) => getValue(account, props.valueKey) === props.modelValue
        );
        if (found) return found;
      }
      const activeByFlag = props.accounts.find(
        (account) => account.isActive === true
      );
      if (activeByFlag) return activeByFlag;
      return props.accounts[0] || null;
    });
    const getValue = (obj, key) => {
      return obj?.[key];
    };
    const handleSelect = (item) => {
      const value = getValue(item, props.valueKey);
      emit("update:modelValue", value);
      emit("select", item);
      closeDropdown();
    };
    const handleMenuItemClick = async (onClick) => {
      if (onClick) {
        await onClick();
      }
      closeDropdown();
    };
    const hasChildren = (item) => Array.isArray(item?.children) && item.children.length > 0;
    const getNumericIndex = (index) => typeof index === "number" ? index : Number(index);
    const setMenuRowRef = (index, el) => {
      const candidate = el instanceof Element ? el : el && "$el" in el ? el.$el : null;
      if (candidate instanceof HTMLElement) {
        menuRowRefs.value[index] = candidate;
        return;
      }
      delete menuRowRefs.value[index];
    };
    const setSubmenuItemRef = (index, el) => {
      const numericIndex = getNumericIndex(index);
      const candidate = el instanceof Element ? el : el && "$el" in el ? el.$el : null;
      if (candidate instanceof HTMLElement) {
        submenuItemRefs.value[numericIndex] = candidate;
        return;
      }
      delete submenuItemRefs.value[numericIndex];
    };
    const clearSubmenuCloseTimer = () => {
      if (submenuCloseTimer) {
        clearTimeout(submenuCloseTimer);
        submenuCloseTimer = null;
      }
    };
    const queueCloseSubmenu = () => {
      clearSubmenuCloseTimer();
      submenuCloseTimer = setTimeout(() => {
        activeSubmenuIndex.value = null;
        activeNestedSubmenuIndex.value = null;
      }, 120);
    };
    const updateSubmenuPosition = (index) => {
      const anchor = menuRowRefs.value[index];
      const item = props.menuItems[index];
      if (!anchor || !hasChildren(item)) return;
      activeSubmenuAnchor.value = anchor;
    };
    const openSubmenu = (index) => {
      clearSubmenuCloseTimer();
      activeSubmenuIndex.value = index;
      activeNestedSubmenuIndex.value = null;
      nextTick(() => updateSubmenuPosition(index));
    };
    const updateNestedSubmenuPosition = (index) => {
      const numericIndex = getNumericIndex(index);
      const anchor = submenuItemRefs.value[numericIndex];
      const child = activeSubmenuItems.value[numericIndex];
      if (!anchor || !hasChildren(child)) return;
      activeNestedSubmenuAnchor.value = anchor;
    };
    const openNestedSubmenu = (index) => {
      const numericIndex = getNumericIndex(index);
      clearSubmenuCloseTimer();
      nestedSubmenuSearchQuery.value = "";
      activeNestedSubmenuIndex.value = numericIndex;
      nextTick(() => updateNestedSubmenuPosition(numericIndex));
    };
    const closeNestedSubmenu = () => {
      nestedSubmenuSearchQuery.value = "";
      activeNestedSubmenuIndex.value = null;
    };
    const closeSubmenu = () => {
      clearSubmenuCloseTimer();
      activeSubmenuIndex.value = null;
      activeNestedSubmenuIndex.value = null;
    };
    const handleMenuRowClick = (item, index) => {
      if (hasChildren(item)) {
        clearSubmenuCloseTimer();
        if (activeSubmenuIndex.value === index) {
          closeSubmenu();
          return;
        }
        openSubmenu(index);
        return;
      }
      void handleMenuItemClick(item.onClick);
    };
    const handleSubmenuItemClick = async (child, index) => {
      const numericIndex = getNumericIndex(index);
      if (hasChildren(child)) {
        if (activeNestedSubmenuIndex.value === numericIndex) {
          closeNestedSubmenu();
          return;
        }
        openNestedSubmenu(numericIndex);
        return;
      }
      if (typeof child?.onClick === "function") {
        await child.onClick();
      }
      closeDropdown();
    };
    const closeDropdown = () => {
      closeSubmenu();
      nextTick(() => {
        document.dispatchEvent(new MouseEvent("mousedown", { bubbles: true }));
      });
    };
    const isItemActive = (item) => {
      if (!activeAccount.value) return false;
      return getValue(item, props.valueKey) === getValue(activeAccount.value, props.valueKey);
    };
    const displayName = computed(() => {
      if (activeAccount.value) {
        return getValue(activeAccount.value, props.labelKey) || "";
      }
      return props.userName || "";
    });
    const displayEmail = computed(() => {
      if (activeAccount.value) {
        return getValue(activeAccount.value, props.descKey) || "";
      }
      return props.userEmail || "";
    });
    const displayAvatar = computed(() => {
      if (activeAccount.value) {
        return getValue(activeAccount.value, props.avatarKey) || "";
      }
      return props.userAvatar || "";
    });
    const filteredAccounts = computed(() => {
      if (!searchQuery.value) return props.accounts;
      const query = searchQuery.value.toLowerCase();
      return props.accounts.filter((account) => {
        const name = getValue(account, props.labelKey) || "";
        const desc = getValue(account, props.descKey) || "";
        return name.toLowerCase().includes(query) || desc.toLowerCase().includes(query);
      });
    });
    const activeSubmenuItems = computed(() => {
      if (activeSubmenuIndex.value === null) return [];
      const menuItem = props.menuItems[activeSubmenuIndex.value];
      if (!hasChildren(menuItem)) return [];
      return menuItem.children;
    });
    const activeNestedSubmenuItems = computed(() => {
      if (activeNestedSubmenuIndex.value === null) return [];
      const submenuItem = activeSubmenuItems.value[activeNestedSubmenuIndex.value];
      if (!hasChildren(submenuItem)) return [];
      return submenuItem.children;
    });
    const activeNestedSubmenuItem = computed(() => {
      if (activeNestedSubmenuIndex.value === null) return null;
      return activeSubmenuItems.value[activeNestedSubmenuIndex.value];
    });
    const isNestedSubmenuSearchable = computed(() => {
      return Boolean(activeNestedSubmenuItem.value?.searchable);
    });
    const nestedSubmenuSearchPlaceholder = computed(() => {
      return activeNestedSubmenuItem.value?.searchPlaceholder ?? "Search languages";
    });
    const filteredNestedSubmenuItems = computed(() => {
      if (!isNestedSubmenuSearchable.value) return activeNestedSubmenuItems.value;
      const query = nestedSubmenuSearchQuery.value.trim().toLowerCase();
      if (!query) return activeNestedSubmenuItems.value;
      return activeNestedSubmenuItems.value.filter((item) => {
        const itemLabel = String(item?.label ?? "").toLowerCase();
        const itemDescription = String(item?.description ?? "").toLowerCase();
        return itemLabel.includes(query) || itemDescription.includes(query);
      });
    });
    onBeforeUnmount(() => {
      clearSubmenuCloseTimer();
    });
    __expose({
      dropdownRef,
      closeDropdown
    });
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", _hoisted_1, [
        createVNode(Dropdown, {
          ref_key: "dropdownRef",
          ref: dropdownRef,
          placement: "bottom-end"
        }, {
          dropdown: withCtx(() => [
            renderSlot(_ctx.$slots, "default", {
              user: {
                name: displayName.value,
                email: displayEmail.value,
                avatar: displayAvatar.value
              },
              accounts: props.accounts,
              activeAccount: activeAccount.value
            }, () => [
              createElementVNode("div", {
                class: "profile-dropdown__menu",
                style: normalizeStyle({ maxWidth: props.maxWidth })
              }, [
                __props.searchable ? (openBlock(), createElementBlock("div", _hoisted_5, [
                  createVNode(Input, {
                    modelValue: searchQuery.value,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => searchQuery.value = $event),
                    type: "text",
                    placeholder: __props.searchPlaceholder,
                    class: "profile-dropdown__search-input"
                  }, {
                    prefix: withCtx(() => [
                      createVNode(unref(SearchIcon))
                    ]),
                    _: 1
                  }, 8, ["modelValue", "placeholder"])
                ])) : createCommentVNode("", true),
                renderSlot(_ctx.$slots, "info", {
                  user: {
                    name: displayName.value,
                    email: displayEmail.value,
                    avatar: displayAvatar.value
                  }
                }, void 0, true),
                createElementVNode("div", _hoisted_6, [
                  (_ctx.$slots.header || !__props.accounts.length) && !_ctx.$slots.info ? renderSlot(_ctx.$slots, "header", {
                    key: 0,
                    user: {
                      name: displayName.value,
                      email: displayEmail.value,
                      avatar: displayAvatar.value
                    }
                  }, () => [
                    !__props.accounts.length ? (openBlock(), createElementBlock("div", _hoisted_7, [
                      createVNode(Avatar, {
                        size: "sm",
                        "avatar-url": displayAvatar.value,
                        title: displayName.value,
                        "show-titles": false
                      }, null, 8, ["avatar-url", "title"]),
                      createElementVNode("div", _hoisted_8, [
                        createElementVNode("div", _hoisted_9, toDisplayString(displayName.value), 1),
                        displayEmail.value ? (openBlock(), createElementBlock("div", _hoisted_10, toDisplayString(displayEmail.value), 1)) : createCommentVNode("", true)
                      ])
                    ])) : createCommentVNode("", true)
                  ], true) : createCommentVNode("", true),
                  !__props.accounts.length && !_ctx.$slots.header && !_ctx.$slots.info ? (openBlock(), createElementBlock("div", _hoisted_11)) : createCommentVNode("", true),
                  __props.accounts.length && filteredAccounts.value.length ? (openBlock(), createElementBlock("div", _hoisted_12, [
                    renderSlot(_ctx.$slots, "accounts", {
                      accounts: filteredAccounts.value,
                      searchQuery: searchQuery.value
                    }, () => [
                      createElementVNode("div", _hoisted_13, [
                        (openBlock(true), createElementBlock(Fragment, null, renderList(filteredAccounts.value, (account) => {
                          return renderSlot(_ctx.$slots, "option", {
                            key: getValue(account, __props.valueKey),
                            item: account,
                            isActive: isItemActive(account),
                            select: handleSelect
                          }, () => [
                            createVNode(ProfileDropdownItem, {
                              item: account,
                              "is-active": isItemActive(account),
                              "value-key": __props.valueKey,
                              "label-key": __props.labelKey,
                              "avatar-key": __props.avatarKey,
                              "desc-key": __props.descKey,
                              onClick: ($event) => handleSelect(account)
                            }, null, 8, ["item", "is-active", "value-key", "label-key", "avatar-key", "desc-key", "onClick"])
                          ], true);
                        }), 128))
                      ])
                    ], true),
                    _cache[7] || (_cache[7] = createElementVNode("div", { class: "profile-dropdown__divider" }, null, -1))
                  ])) : createCommentVNode("", true),
                  _ctx.$slots.menu || __props.menuItems.length ? renderSlot(_ctx.$slots, "menu", { key: 3 }, () => [
                    __props.menuItems.length ? (openBlock(), createElementBlock("div", _hoisted_14, [
                      (openBlock(true), createElementBlock(Fragment, null, renderList(__props.menuItems, (item, index) => {
                        return openBlock(), createElementBlock(Fragment, { key: index }, [
                          item.divider ? (openBlock(), createElementBlock("div", _hoisted_15)) : createCommentVNode("", true),
                          createElementVNode("div", {
                            ref_for: true,
                            ref: (el) => setMenuRowRef(index, el),
                            class: "profile-dropdown__menu-row",
                            onMouseenter: ($event) => hasChildren(item) && openSubmenu(index),
                            onMouseleave: ($event) => hasChildren(item) && queueCloseSubmenu()
                          }, [
                            createVNode(ProfileDropdownMenuItem, {
                              label: item.label,
                              icon: item.icon,
                              variant: item.variant,
                              "has-children": hasChildren(item),
                              onClick: ($event) => handleMenuRowClick(item, index)
                            }, null, 8, ["label", "icon", "variant", "has-children", "onClick"])
                          ], 40, _hoisted_16)
                        ], 64);
                      }), 128))
                    ])) : createCommentVNode("", true),
                    (openBlock(), createBlock(Teleport, { to: "body" }, [
                      activeSubmenuIndex.value !== null && activeSubmenuItems.value.length ? (openBlock(), createElementBlock("div", {
                        key: 0,
                        ref_key: "submenuFloatingRef",
                        ref: submenuFloatingRef,
                        class: "profile-dropdown__submenu profile-dropdown__submenu--floating",
                        style: normalizeStyle(unref(submenuFloatingStyles)),
                        role: "menu",
                        onMousedown: _cache[2] || (_cache[2] = withModifiers(() => {
                        }, ["stop"])),
                        onMouseenter: clearSubmenuCloseTimer,
                        onMouseleave: queueCloseSubmenu
                      }, [
                        (openBlock(true), createElementBlock(Fragment, null, renderList(activeSubmenuItems.value, (child, childIndex) => {
                          return openBlock(), createElementBlock("button", {
                            key: childIndex,
                            ref_for: true,
                            ref: (el) => setSubmenuItemRef(childIndex, el),
                            type: "button",
                            class: normalizeClass(["profile-dropdown__submenu-item", {
                              "profile-dropdown__submenu-item--active": child.isActive
                            }]),
                            onMouseenter: ($event) => hasChildren(child) ? openNestedSubmenu(childIndex) : closeNestedSubmenu(),
                            onMousedown: _cache[1] || (_cache[1] = withModifiers(() => {
                            }, ["stop"])),
                            onClick: ($event) => void handleSubmenuItemClick(child, childIndex)
                          }, [
                            child.icon && !child.avatar ? (openBlock(), createElementBlock("span", _hoisted_18, [
                              (openBlock(), createBlock(resolveDynamicComponent(child.icon)))
                            ])) : child.avatar ? (openBlock(), createBlock(Avatar, {
                              key: 1,
                              size: "sm",
                              "avatar-url": child.avatar,
                              title: child.label,
                              "show-titles": false
                            }, null, 8, ["avatar-url", "title"])) : createCommentVNode("", true),
                            createElementVNode("div", _hoisted_19, [
                              createElementVNode("div", _hoisted_20, toDisplayString(child.label), 1),
                              child.description ? (openBlock(), createElementBlock("div", _hoisted_21, toDisplayString(child.description), 1)) : createCommentVNode("", true)
                            ]),
                            hasChildren(child) ? (openBlock(), createElementBlock("span", _hoisted_22, [
                              createVNode(unref(ChevronRightIcon))
                            ])) : createCommentVNode("", true)
                          ], 42, _hoisted_17);
                        }), 128))
                      ], 36)) : createCommentVNode("", true)
                    ])),
                    (openBlock(), createBlock(Teleport, { to: "body" }, [
                      activeNestedSubmenuIndex.value !== null && activeNestedSubmenuItems.value.length ? (openBlock(), createElementBlock("div", {
                        key: 0,
                        ref_key: "nestedSubmenuFloatingRef",
                        ref: nestedSubmenuFloatingRef,
                        class: normalizeClass(["profile-dropdown__submenu profile-dropdown__submenu--floating", {
                          "profile-dropdown__submenu--searchable": isNestedSubmenuSearchable.value
                        }]),
                        style: normalizeStyle(unref(nestedSubmenuFloatingStyles)),
                        role: "menu",
                        onMousedown: _cache[5] || (_cache[5] = withModifiers(() => {
                        }, ["stop"])),
                        onMouseenter: clearSubmenuCloseTimer,
                        onMouseleave: queueCloseSubmenu
                      }, [
                        isNestedSubmenuSearchable.value ? (openBlock(), createElementBlock("div", _hoisted_23, [
                          createVNode(Input, {
                            modelValue: nestedSubmenuSearchQuery.value,
                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => nestedSubmenuSearchQuery.value = $event),
                            type: "text",
                            placeholder: nestedSubmenuSearchPlaceholder.value,
                            class: "profile-dropdown__search-input"
                          }, {
                            prefix: withCtx(() => [
                              createVNode(unref(SearchIcon))
                            ]),
                            _: 1
                          }, 8, ["modelValue", "placeholder"])
                        ])) : createCommentVNode("", true),
                        (openBlock(true), createElementBlock(Fragment, null, renderList(filteredNestedSubmenuItems.value, (nestedChild, nestedChildIndex) => {
                          return openBlock(), createElementBlock("button", {
                            key: nestedChildIndex,
                            type: "button",
                            class: normalizeClass(["profile-dropdown__submenu-item", {
                              "profile-dropdown__submenu-item--active": nestedChild.isActive
                            }]),
                            onMousedown: _cache[4] || (_cache[4] = withModifiers(() => {
                            }, ["stop"])),
                            onClick: ($event) => void handleSubmenuItemClick(
                              nestedChild,
                              nestedChildIndex
                            )
                          }, [
                            createElementVNode("div", _hoisted_25, [
                              createElementVNode("div", _hoisted_26, toDisplayString(nestedChild.label), 1),
                              nestedChild.description ? (openBlock(), createElementBlock("div", _hoisted_27, toDisplayString(nestedChild.description), 1)) : createCommentVNode("", true)
                            ])
                          ], 42, _hoisted_24);
                        }), 128))
                      ], 38)) : createCommentVNode("", true)
                    ]))
                  ], true) : createCommentVNode("", true)
                ]),
                _ctx.$slots.timezone || __props.timezone ? (openBlock(), createElementBlock("div", _hoisted_28, [
                  renderSlot(_ctx.$slots, "timezone", {
                    timezone: __props.timezone,
                    timezoneOffset: __props.timezoneOffset
                  }, () => [
                    createElementVNode("div", _hoisted_29, [
                      createElementVNode("span", _hoisted_30, [
                        createVNode(unref(Globe02StrokeRoundedIcon))
                      ]),
                      createElementVNode("div", _hoisted_31, [
                        createElementVNode("p", _hoisted_32, toDisplayString(__props.timezone), 1),
                        __props.timezoneOffset ? (openBlock(), createElementBlock("p", _hoisted_33, toDisplayString(__props.timezoneOffset), 1)) : createCommentVNode("", true)
                      ])
                    ])
                  ], true)
                ])) : createCommentVNode("", true)
              ], 4)
            ], true)
          ]),
          default: withCtx(() => [
            renderSlot(_ctx.$slots, "trigger", {
              user: {
                name: displayName.value,
                email: displayEmail.value,
                avatar: displayAvatar.value
              }
            }, () => [
              __props.displayMode === "name" ? (openBlock(), createElementBlock("button", _hoisted_2, [
                createVNode(Avatar, {
                  size: "sm",
                  "avatar-url": displayAvatar.value || void 0,
                  title: displayName.value || "",
                  "show-titles": false,
                  indicator: props.isAdmin ? "company-badge" : "none",
                  "company-badge": props.isAdmin ? unref(StarBadge) : void 0
                }, null, 8, ["avatar-url", "title", "indicator", "company-badge"]),
                createElementVNode("span", _hoisted_3, toDisplayString(displayName.value), 1),
                _cache[6] || (_cache[6] = createElementVNode("svg", {
                  class: "profile-dropdown__chevron",
                  xmlns: "http://www.w3.org/2000/svg",
                  width: "10",
                  height: "6",
                  viewBox: "0 0 10 6",
                  fill: "none"
                }, [
                  createElementVNode("path", {
                    d: "M8.75 0.750033C8.75 0.750033 5.80407 4.75 4.75 4.75C3.69587 4.75 0.75 0.75 0.75 0.75",
                    stroke: "#F7F7FC",
                    "stroke-width": "1.5",
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round"
                  })
                ], -1))
              ])) : (openBlock(), createElementBlock("button", _hoisted_4, [
                createVNode(Avatar, {
                  size: "sm",
                  "avatar-url": displayAvatar.value || void 0,
                  title: displayName.value,
                  "show-titles": false,
                  indicator: props.isAdmin ? "company-badge" : "none",
                  "company-badge": props.isAdmin ? unref(StarBadge) : void 0
                }, null, 8, ["avatar-url", "title", "indicator", "company-badge"])
              ]))
            ], true)
          ]),
          _: 3
        }, 512)
      ]);
    };
  }
});
export {
  _sfc_main as default
};
//# sourceMappingURL=ProfileDropdown.vue2.js.map
